import loadMoreButton from '~/js/lib/collection'; // eslint-disable-line

export default (node) => {
  /**
   * Data + elements
   */
  const overlay = document.querySelector('[data-filter-mobile-overlay]');
  const collectionProducts = document.querySelector(
    '[data-collection-products]'
  );
  const closeButton = node.querySelector('[data-button-close]');
  const contentLoading = node.querySelector('[data-filter-content-loading]');
  let closeListener = null;

  /**
   * Functions
   */
  const openFilterMobile = () => {
    node.classList.add('!translate-y-0');
    node.classList.remove('opacity-0');
    node.classList.add('md:!translate-x-0');
    overlay.classList.remove('hidden');
    closeListener = closeButton.addEventListener('click', closeFilterMobile);
  };

  const closeFilterMobile = () => {
    node.classList.add('opacity-0');
    node.classList.remove('!translate-y-0');
    node.classList.remove('md:!translate-x-0');
    overlay.classList.add('hidden');
    closeListener = closeButton.removeEventListener('click', closeFilterMobile);
    // dispatch event to close mobile filter
    document.dispatchEvent(new CustomEvent('filter-mobile:close'));
  };

  // apply the filters to the collection
  const applyFilters = (e) => {
    let element = null;
    if (e.detail) {
      element = e.detail.button;
    } else {
      element = e.currentTarget;
    }

    const urlToAdd = element.dataset.filterUrlToAdd;
    const urlToRemove = element.dataset.filterUrlToRemove;
    const isChecked = element.checked;
    let urlToCall = isChecked ? urlToAdd : urlToRemove;

    processCollectionWithFilters(urlToCall);
    window.history.pushState({}, '', urlToCall);
  };

  const applySort = (e) => {
    // e.preventDefault();
    const sortValue = e.target.dataset.applySortMobile;
    // check if the url has sort_by parameter, if exits replace it with the new value else add it
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    searchParams.set('sort_by', sortValue);
    // modify the url with the new search params without reloading the page
    const urlToCall = `${url.origin}${url.pathname}?${searchParams.toString()}`;
    window.history.pushState({}, '', urlToCall);

    processCollectionWithFilters(urlToCall);
  };

  const processCollectionWithFilters = (urlToCall) => {
    contentLoading.classList.remove('hidden');

    loadMoreButton(urlToCall).then((products) => {
      // get the products from the response
      const resultsMarkup = products.querySelector(
        '[data-collection-products]'
      ).innerHTML;
      // append the products to the current collection
      if (collectionProducts) {
        collectionProducts.innerHTML = resultsMarkup;
      }

      // update filter footer
      const filterFooter = products.querySelector(
        '[data-filter-mobile-footer]'
      );
      if (filterFooter) {
        const currentFilterFooter = document.querySelector(
          '[data-filter-mobile-footer]'
        );
        currentFilterFooter.innerHTML = filterFooter.innerHTML;
      }

      // update results count
      const resultsCount = products.querySelector(
        '[data-filter-results-count]'
      );
      if (resultsCount) {
        const currentResultsCount = document.querySelector(
          '[data-filter-results-count]'
        );
        currentResultsCount.innerHTML = resultsCount.innerHTML;
      }

      // update the filters
      const currentFilterContainer = document.querySelector(
        '[data-filter-container-mobile]'
      );
      if (currentFilterContainer) {
        currentFilterContainer.innerHTML = products.querySelector(
          '[data-filter-container-mobile]'
        ).innerHTML;
        document.dispatchEvent(
          new CustomEvent('shopify:section:load:accordion', {
            detail: {
              node: currentFilterContainer,
            },
          })
        );
      }

      // update the filters applied
      const currentFiltersApplied = document.querySelector(
        '[data-collection-filters-applied]'
      );
      if (currentFiltersApplied) {
        currentFiltersApplied.innerHTML = products.querySelector(
          '[data-collection-filters-applied]'
        ).innerHTML;
      }

      document.dispatchEvent(
        new CustomEvent('collection-filter:add-listeners')
      );
      initEventListeners();
      contentLoading.classList.add('hidden');
    });
  };

  const initEventListeners = () => {
    const sortOptions = node.querySelectorAll('[data-apply-sort-mobile]');
    const filtersOptions = node.querySelectorAll('[data-apply-filter-mobile]');

    sortOptions.forEach((option) => {
      option.addEventListener('click', applySort);
    });
    filtersOptions.forEach((option) => {
      option.addEventListener('change', applyFilters);
    });

    const closeButton = node.querySelector('[data-button-close]');
    const doneButton = node.querySelector('[data-filter-done]');
    closeButton.addEventListener('click', closeFilterMobile);
    doneButton.addEventListener('click', closeFilterMobile);
  };

  /**
   * Init
   */
  const init = () => {
    document.addEventListener('filter-mobile:open', openFilterMobile);
    document.addEventListener('filter-mobile:remove-filter', applyFilters);
    if (overlay) overlay.addEventListener('click', closeFilterMobile);
    initEventListeners();
  };

  init();
};
